import React, {useState} from "react";
import * as palette from "../Variables";
import styled from "styled-components";

const StyledInsight = styled.div`
    display: flex;
    flex-flow: row nowrap;
    column-gap: 12px;
    align-items: flex-start;

    &.no-title {
        .title, br {
            display: none;
        }

        p {
            margin-top: 4px;
        }

        p.h4 {
            margin-top: 0;}
    }

    @media (min-width: 768px) {
        column-gap: 24px;
    }

    .number p {
        color: ${palette.neutral8};
        display: inline-block;
        width: 26px;
    }

    .text p span {
        line-height: 2em;
    }

    .text p {
        margin-bottom: 0;
    }
`;

const Insight = ({number, title, description, className}) => {
    return (
        <StyledInsight className={className}>
            <div className={"number"}>
                <p className={"h4"}>{number}</p>
            </div>
            <div className={"text"}>
                <p><span className={"title semibold"}>{title}</span><br/>{description}</p>
            </div>
        </StyledInsight>
    )
}

export default Insight;